/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumSiteStatus = {
	Overproof: 					new EnumItem('超标', 0),
	Normal: 					new EnumItem('正常', 1),
	Malfunction: 					new EnumItem('故障', 2),
	...enumMixn
}
export default EnumSiteStatus
